import { Button } from '@mui/material';
import * as React from 'react';
import StringResourceManager, { GetString } from '../StringResourceManager';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import UserManagementForm from './UserManagementForm';

const UserManagementModal: React.FC = ({}): React.ReactElement => {
  const [UserManagementModalVisible, setUserManagementModalVisible] =
    React.useState<boolean>(false);

  const handleOpen = () => {
    setUserManagementModalVisible(true);
  };

  const handleClose = () => {
    setUserManagementModalVisible(false);
  };
  const DONE_STR = GetString('DONE');

  return (
    <React.Fragment>
      <div>
        <Button onClick={handleOpen} variant="contained">
          {GetString('USER_MANAGEMENT_BUTTON')}
        </Button>
        {UserManagementModalVisible && (
          <Dialog
            onClose={handleClose}
            title={
              <StringResourceManager
                stringKey="PAGE_TITLE_USER_MANAGEMENT"
                style="dialogTitle"
                variant="h1"
              />
            }
            width="800px"
          >
            <UserManagementForm></UserManagementForm>
            <DialogActionsBar layout="center">
              <Button color="primary" variant="contained" onClick={handleClose}>
                {DONE_STR}
              </Button>
            </DialogActionsBar>
          </Dialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default UserManagementModal;
